import { Component, OnInit } from '@angular/core';
import {NgbActiveModal, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lba-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
})
export class DatepickerComponent implements OnInit {

  isStartTime: boolean;

  doShowTime: boolean = false;

  now = new Date();

  modelDatePicker: NgbDateStruct;
  date: {year: number, month: number, day: number, hour: number, minute: number};
  time = {hour: 0, minute: 0};

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.selectToday();
  }

  selectToday() {
    this.modelDatePicker = {
      year: this.now.getFullYear(),
      month: this.now.getMonth() + 1,
      day: this.now.getDate()};
  }

  closeModal() {
    this.date.day = this.modelDatePicker.day;
    this.date.hour = this.time.hour;
    this.date.minute = this.time.minute;
    this.activeModal.close(this.date);
  }

}
